import React, { useState } from "react";
import GridToolbarNoExport from "../../../common/GridToolbarNoExport";
import AppDataGrid from "../../../common/AppDataGrid";
import { Dialog, DialogContent, IconButton, Snackbar } from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import useData from "../hooks/useData";
import EditForm from "./EditForm";
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ConfirmDeleteDialog from "../../../common/ConfirmDeleteDialog";

const CrudTable = () => {
  const { data, loading, error, updateData, deleteData } = useData();
  const [selectedD, setSelectedD] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleEditClick = (dId) => {
    const d = data.find((item) => item.id === dId);
    setSelectedD(d);
    setEditDialogOpen(true);
  };

  const handleDeleteClick = (dId) => {
    const d = data.find((item) => item.id === dId);
    setSelectedD(d);
    setDeleteDialogOpen(true);
  };

  const handleEditFormClose = () => {
    setEditDialogOpen(false);
    setSelectedD(null);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
    setSelectedD(null);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleUpdate = async (updatedData) => {
    try {
      await updateData(updatedData);
      setSnackbarOpen(true);
      handleEditFormClose();
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  const handleDelete = async () => {
    try {
      await deleteData(selectedD.id);
      setSnackbarOpen(true);
      handleDeleteDialogClose();
    } catch (error) {
      console.error("Error deleting data:", error);
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "Id",
      flex: 1,
    },
    {
      field: "school_name",
      headerName: "School Name",
      flex: 1,
    },
    {
      field: "district",
      headerName: "District",
      flex: 1,
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <IconButton
            onClick={() => handleEditClick(params.row.id)}
            color="primary"
          >
            <EditIcon />
          </IconButton>
          <IconButton
            onClick={() => handleDeleteClick(params.row.id)}
            color="error"
          >
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <>
      <AppDataGrid
        rows={data}
        columns={columns}
        loading={loading}
        slots={{ toolbar: GridToolbarNoExport }}
        pagination
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50]}
        disableSelectionOnClick
        initialState={{
          columns: {
            columnVisibilityModel: {
              id: false,
            },
          },
        }}
      />
      <Dialog open={editDialogOpen} onClose={handleEditFormClose}>
        <ModalDialogTitle onClose={handleEditFormClose}>
          Edit Faq
        </ModalDialogTitle>
        <DialogContent>
          {selectedD && (
            <EditForm initialData={selectedD} onUpdate={handleUpdate} />
          )}
        </DialogContent>
      </Dialog>
      <ConfirmDeleteDialog
        open={deleteDialogOpen}
        onClose={handleDeleteDialogClose}
        onConfirm={handleDelete}
        title="Confirm Delete"
        message="Are you sure you want to delete this item? This action cannot be undone."
      />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message="Item has been updated"
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      />
    </>
  );
};

export default CrudTable;
